/*
 *   Copyright (c) 2022 Luxembourg Institute of Science and Technology
 *   All rights reserved.
 *   See License in the LICENSE file
 */
import * as React from "react";
import ErasmusLogo from "../../assets/logos/funding.png";
import "./footer.scss";

const Footer = () => {
  return (
    <div className="footer bg-footer flex flex-col">
      <div className="container w-[93.8%] mx-[6.2%] grid max-sm:grid-rows-3 sm:grid-cols-3 gap-3 mb-10">
        <div className="mx-5">
          <div className="py-[42px]">
            <a href="https://www.fairnessinteaching-project.eu/fit-partnership">
              <h2 className="underline decoration-primary underline-offset-[6px] decoration-2 text-lightgray">
                FIT Partnership
              </h2>
            </a>
          </div>
          <div className="py-[42px] mt-[-42px]">
            <a href="https://www.anefore.lu/">
              <h2 className="underline decoration-primary underline-offset-[6px] decoration-2 text-lightgray">
                Funding Authority
              </h2>
            </a>
          </div>
          <div className="py-[42px] mt-[-42px]">
            <div className="bg-lightgray w-full">
              <img className="w-[295px]" src={ErasmusLogo}></img>
            </div>
          </div>
        </div>
        <div className="mx-5">
          <div className="py-[42px]">
            <a href="https://browse.fairnessinteaching-project.eu/">
              <h2 className="underline decoration-primary underline-offset-[6px] decoration-2 text-lightgray">
                Browse
              </h2>
            </a>
          </div>
          <div className="py-[42px] mt-[-42px]">
            <a href="https://www.fairnessinteaching-project.eu/boost-your-practices">
              <h2 className="underline decoration-primary underline-offset-[6px] decoration-2 text-lightgray">
                Boost your practices
              </h2>
            </a>
          </div>
          <div className="py-[42px] mt-[-42px]">
            <a href="https://browse.fairnessinteaching-project.eu/contribute">
              <h2 className="underline decoration-primary underline-offset-[6px] decoration-2 text-lightgray">
                Contribute
              </h2>
            </a>
          </div>
        </div>
        <div className="mx-5">
          <div className="py-[42px]">
            <a href="https://www.fairnessinteaching-project.eu/fit-project-description">
              <h2 className="underline decoration-primary underline-offset-[6px] decoration-2 text-lightgray">
                Project description
              </h2>
            </a>
          </div>
          <div className="py-[42px] mt-[-42px]">
            <a href="mailto:info@fit.lu">
              <h2 className="underline decoration-primary underline-offset-[6px] decoration-2 text-lightgray">
                Contact us
              </h2>
            </a>
          </div>
          <div className="py-[42px] mt-[-42px]">
            <a href="https://www.fairnessinteaching-project.eu/legal-notice">
              <h2 className="underline decoration-primary underline-offset-[6px] decoration-2 text-lightgray">
                Legal Notice
              </h2>
            </a>
          </div>
          <div className="py-[42px] mt-[-42px]">
            <a href="https://www.fairnessinteaching-project.eu/privacy-policy">
              <h2 className="underline decoration-primary underline-offset-[6px] decoration-2 text-lightgray">
                Privacy Notice
              </h2>
            </a>
          </div>
        </div>
      </div>
      <div className="flex text-lightgray text-base py-[36px]">
        <p className="m-auto max-md:mx-8 max-md:text-center mt-[10px] leading-[46px]">
          © Copyright 2023 Luxembourg Institute of Science and Technology -{" "}
          <a target="_blank" href="https://www.list.lu">
            LIST
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
